import type { FC } from 'react'

import type { TIconSvgProps } from './icon.types'

export const IconSbp: FC<TIconSvgProps> = ({ size = 24, padding = 0, onClick }) => {
    return (
        <svg
            fill='none'
            height={size + padding * 2}
            style={{ padding: `${padding}px` }}
            viewBox='0 0 24 24'
            width={size + padding * 2}
            xmlns='http://www.w3.org/2000/svg'
            onClick={onClick}
        >
            <path d='M2 5.22461L4.98763 10.4204V13.5897L2.0035 18.7752L2 5.22461Z' fill='#5B57A2' />
            <path
                d='M13.4707 8.52914L16.2702 6.85969L21.9996 6.85449L13.4707 11.9381V8.52914Z'
                fill='#D90751'
            />
            <path
                d='M13.4544 5.19418L13.4702 12.0732L10.4756 10.2829V0L13.4544 5.19418Z'
                fill='#FAB718'
            />
            <path
                d='M21.9991 6.85522L16.2695 6.86043L13.4544 5.19418L10.4756 0L21.9991 6.85522Z'
                fill='#ED6F26'
            />
            <path
                d='M13.4702 18.7998V15.4623L10.4756 13.7061L10.4772 23.9992L13.4702 18.7998Z'
                fill='#63B22F'
            />
            <path
                d='M16.2638 17.1498L4.98743 10.4204L2 5.22461L21.9881 17.143L16.2638 17.1498Z'
                fill='#1487C9'
            />
            <path
                d='M10.4775 24.0001L13.4701 18.8007L16.2626 17.1464L21.9869 17.1396L10.4775 24.0001Z'
                fill='#017F36'
            />
            <path
                d='M2.00391 18.7691L10.5016 13.7044L7.64467 11.9989L4.98804 13.5835L2.00391 18.7691Z'
                fill='#984995'
            />
        </svg>
    )
}
